import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const timeoutRef = React.useRef(null);



  const menus = {
    about: [
      { label: "Who We Are", path: "/about/who-we-are" },
      { label: "Christianity", path: "/about/christianity" },
      { label: "Our Beliefs", path: "/about/ourBeliefs" },
    ],
    resources: [
      { label: "Sermons", path: "/resources/sermons" },
      { label: "Gospel Tracts", path: "/resources/gospel" },
      { label: "Bakht Singh Books", path: "/resources/bakthsingh" },
      { label: "Announcements", path: "/resources/announcements" },
      { label: "Songs", path: "/resources/songs" },
    ],
  };


  const handleNavHover = (event, menuKey) => {
    clearTimeout(timeoutRef.current);
    setActiveMenu(menuKey);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    timeoutRef.current = setTimeout(() => {
      setActiveMenu(null);
      setAnchorEl(null);
    }, 1200);
  };

  const cancelMenuClose = () => {
    clearTimeout(timeoutRef.current);
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setActiveMenu(null);
    setAnchorEl(null);
    setMobileOpen(false);
  };

  const navItemStyle = {
    color: "white",
    px: 2,
    cursor: "pointer",
    borderRight: "1px solid white",
    "&:last-child": { borderRight: "none" },
  };

  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
    setExpandedMenu(null);
  };

  const toggleSubMenu = (key) => {
    setExpandedMenu((prev) => (prev === key ? null : key));
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "transparent", padding: "5px 0" }}>
      <Toolbar>
        <Typography
          variant="h4"
          sx={{
            flexGrow: 1, cursor: "pointer",
            fontSize: {
              xs: "1.2rem",
              sm: "1.5rem",
              md: "2rem",
              lg: "2.5rem"
            }
          }}
          onClick={() => navigate("/")}
        >
          Canberra Hebron Church
        </Typography>

        {isMobile ? (
          <>
            <IconButton color="inherit" onClick={toggleMobileMenu}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="right" open={mobileOpen} onClose={toggleMobileMenu}
              PaperProps={{
                sx: {
                  backgroundColor: "transparent",
                  color: "white",
                  borderLeft: "1px solid white",
                  backdropFilter: "blur(8px)",
                },
              }}
            >
              <Box sx={{ width: 250 }} role="presentation">
                <List>
                  <ListItem button onClick={() => handleMenuItemClick("/")}>
                    <ListItemText primary="Home" />
                  </ListItem>

                  <ListItem button onClick={() => toggleSubMenu("about")}>
                    <ListItemText primary="About Us" />
                    {expandedMenu === "about" ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </ListItem>
                  <Collapse in={expandedMenu === "about"} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {menus.about.map((item, idx) => (
                        <ListItem
                          key={idx}
                          button
                          sx={{ pl: 4 }}
                          onClick={() => handleMenuItemClick(item.path)}
                        >
                          <ListItemText primary={item.label} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>

                  <ListItem button onClick={() => toggleSubMenu("resources")}>
                    <ListItemText primary="Resources" />
                    {expandedMenu === "resources" ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </ListItem>
                  <Collapse in={expandedMenu === "resources"} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {menus.resources.map((item, idx) => (
                        <ListItem
                          key={idx}
                          button
                          sx={{ pl: 4 }}
                          onClick={() => handleMenuItemClick(item.path)}
                        >
                          <ListItemText primary={item.label} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>

                  <ListItem button onClick={() => handleMenuItemClick("/contactus")}>
                    <ListItemText primary="Contact Us" />
                  </ListItem>
                </List>
              </Box>
            </Drawer>
          </>
        ) : (

          <Box component="ul" sx={{ display: "flex", listStyle: "none", m: 0, p: 0 }} onMouseLeave={handleMenuClose} >

            <Box component="li" sx={navItemStyle} onClick={() => navigate("/")}>
              HOME
            </Box>
            <Box component="li" sx={navItemStyle}
              onMouseEnter={(e) => handleNavHover(e, "about")}
            >
              ABOUT US
            </Box>
            <Box component="li" sx={navItemStyle}
              onMouseEnter={(e) => handleNavHover(e, "resources")}

            >
              RESOURCES
            </Box>
            <Box component="li" sx={navItemStyle} onClick={() => navigate("/contactus")}>
              CONTACT US
            </Box>
          </Box>
        )}

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          MenuListProps={{
            onMouseEnter: cancelMenuClose,
            onMouseLeave: handleMenuClose,
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              backgroundColor: "dimgray",
              border: "1px solid white",
              boxShadow: "none",
              mt: 1,
            },
            elevation: 0,
          }}
        >
          {(menus[activeMenu] || []).map((item, idx) => (
            <MenuItem
              key={idx}
              onClick={() => handleMenuItemClick(item.path)}
              sx={{
                backgroundColor: "transparent",
                color: "white",
                borderBottom: "1px solid white",
                "&:hover": { backgroundColor: "#8B6914" },
              }}
            >
              {item.label}
            </MenuItem>
          ))}
        </Menu>

      </Toolbar>
    </AppBar>
  );
};

export default Header;

